import { Grid, Typography } from "@mui/material";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { GroupDetailStatusTag } from "./group-detail-status-tag.component";

interface IGroupDetailNameProps {
  name: string;
  active: Date | null;
}

export const GroupDetailName: FC<IGroupDetailNameProps> = (props) => {
  const { name, active } = props;
  const { t } = useTranslation();

  const getActiveStatusLabel = () => {
    return active === null ? t("general.inactive") : t("general.active");
  };

  return (
    <Grid container direction="row" justifyContent="space-between" spacing={1}>
      <Grid item xs={10} md="auto">
        <Grid container direction="row" spacing={1}>
          <Grid item>
            <Typography variant="h1">{name}</Typography>
          </Grid>
          <Grid item>
            <GroupDetailStatusTag label={getActiveStatusLabel()} type={active === null ? "error" : "success"} />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
